function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
import { hitEventTms } from 'integration-web-core--socle/js/assets/commons/_tms.js';
import { Days } from "./enums/Days";
var storelocatorMap = document.querySelector('.js-storelocator-map');
var storelocatorDataset = storelocatorMap.dataset;
var storeLayerCSS = '/static/css/woosmap/woosmap.css';
var crisisDataset = 'false';
if (document.querySelector('#header') && document.querySelector('#header') !== undefined) {
  crisisDataset = document.querySelector('#header').dataset.crisis;
}
var COOKIE_STORE_ID_NAME = storelocatorDataset.cookiestore;
var NEW_COOKIE_STORE_ID_NAME = storelocatorDataset.newcookiestore;
var SESSION_STORESPACE_ID = 'storeSpaceId';
var device = storelocatorDataset.device;
var myWoosmapPublicKey = storelocatorDataset.woosmapkey;
var referrerUrl = storelocatorDataset.referrer;
var cookieDomain = storelocatorDataset.cookiedomain;
var lang = storelocatorDataset.lang;
var local = storelocatorDataset.local;
var googleApiKey = storelocatorDataset.googleapikey;
var country = storelocatorDataset.country.split(',');
var lat = parseInt(storelocatorDataset.lat);
var lng = parseInt(storelocatorDataset.lng);
var storeSearchMaxDistance = storelocatorDataset.storesearchmaxdistance;
var storeSearchMaxResponses = storelocatorDataset.storesearchmaxresponses;
var isBmStyle = storelocatorDataset.isbmstyle === 'true';
var scriptWoosmap = document.createElement('script');
scriptWoosmap.addEventListener('load', function () {
  scriptGoogleApi.src = 'https://maps.googleapis.com/maps/api/js?key=' + googleApiKey;
});
var scriptGoogleApi = document.createElement('script');
scriptGoogleApi.addEventListener('load', function () {
  window.dispatchEvent(new CustomEvent('initWoosmapStorelocator'));
});
document.body.appendChild(scriptWoosmap);
document.body.appendChild(scriptGoogleApi);
scriptWoosmap.src = 'https://webapp.woosmap.com/webapp.js';
var asyncImportStyle = function asyncImportStyle(src) {
  var styleBlock = document.createElement('link');
  styleBlock.rel = 'stylesheet';
  styleBlock.type = 'text/css';
  styleBlock.href = src;
  document.head.appendChild(styleBlock);
  return styleBlock;
};
var isCSSLoaded = function isCSSLoaded(url) {
  var cssTag = document.getElementsByTagName('link');
  for (var i = cssTag.length; i--;) {
    if (cssTag[i].href.includes(url)) return true;
  }
  return false;
};
var index;
var searchInput = '';
var defaultIconPath = isBmStyle ? '/static/images/bm-default.svg' : '/static/images/lm-default.svg';
var storeLocatorConfig = {
  'theme': {
    'primaryColor': isBmStyle ? '#003a5c' : '#188803'
  },
  'datasource': {
    'maxResponses': storeSearchMaxResponses,
    'maxDistance': storeSearchMaxDistance,
    'useDistanceMatrix': false
  },
  'recommendation': {
    'useRecommendation': false
  },
  'internationalization': {
    'lang': lang,
    'period': local,
    'unitSystem': 0
  },
  'maps': {
    'provider': 'google',
    'apiKey': googleApiKey,
    'localities': {
      'componentRestrictions': {
        'country': country
      }
    }
  },
  'woosmapview': {
    'baseMapStyle': [{
      'featureType': 'administrative',
      'elementType': 'labels.text.fill',
      'stylers': [{
        'color': '#444444'
      }]
    }, {
      'featureType': 'landscape',
      'elementType': 'all',
      'stylers': [{
        'color': '#f2f2f2'
      }]
    }, {
      'featureType': 'poi',
      'elementType': 'all',
      'stylers': [{
        'visibility': 'off'
      }]
    }, {
      'featureType': 'poi',
      'elementType': 'geometry.fill',
      'stylers': [{
        'visibility': 'on'
      }, {
        'color': '#e9e9e9'
      }]
    }, {
      'featureType': 'poi.park',
      'elementType': 'geometry.fill',
      'stylers': [{
        'color': '#deebd8'
      }, {
        'visibility': 'on'
      }]
    }, {
      'featureType': 'road',
      'elementType': 'all',
      'stylers': [{
        'saturation': -100
      }, {
        'lightness': 45
      }]
    }, {
      'featureType': 'road.highway',
      'elementType': 'all',
      'stylers': [{
        'visibility': 'simplified'
      }]
    }, {
      'featureType': 'road.arterial',
      'elementType': 'labels.icon',
      'stylers': [{
        'visibility': 'off'
      }]
    }, {
      'featureType': 'transit',
      'elementType': 'all',
      'stylers': [{
        'visibility': 'off'
      }]
    }, {
      'featureType': 'water',
      'elementType': 'all',
      'stylers': [{
        'color': '#c4e5f3'
      }, {
        'visibility': 'on'
      }]
    }],
    //customize Google Maps basemap (check https://snazzymaps.com/)
    'initialCenter': {
      'lat': lat,
      'lng': lng
    },
    'initialZoom': 6,
    'tileStyle': {
      'color': isBmStyle ? '#C34400' : '#188702',
      'size': 15,
      'minSize': 11
    },
    'breakPoint': 10,
    'style': {
      'default': {
        'icon': {
          url: defaultIconPath,
          scaledSize: {
            height: 42,
            width: 34
          }
        },
        'numberedIcon': {
          url: defaultIconPath,
          scaledSize: {
            height: 42,
            width: 34
          }
        },
        'selectedIcon': {
          url: isBmStyle ? '/static/images/bm-selected.svg' : '/static/images/lm-selected.svg',
          scaledSize: {
            height: 55,
            width: 46
          }
        }
      }
    }
  }
};
var Storelocator = /*#__PURE__*/function (_lm$Composant) {
  function Storelocator(id) {
    var _this;
    _classCallCheck(this, Storelocator);
    _this = _callSuper(this, Storelocator, [id]);
    window.addEventListener('initWoosmapStorelocator', function () {
      if (!isCSSLoaded(storeLayerCSS)) {
        asyncImportStyle(storeLayerCSS);
      }
      var isConcept = '_concept';
      var isFavoriteStoreLineDisplayable = function isFavoriteStoreLineDisplayable(store) {
        return storelocatorDataset.customercontextactive === 'false' && !store.properties.store_id.includes(isConcept);
      };
      var myStoreLocator = new WebApp('component-storelocator', myWoosmapPublicKey);
      myStoreLocator.setFullStoreRenderer(function (store) {
        index = 0;
        var myCustomContent = document.createElement('div');
        myCustomContent.className = 'm-storelocator__store-summary';
        myCustomContent.className += " m-storelocator__store-summary-".concat(isBmStyle ? 'bm' : 'lm');
        var html = [];
        html.push(Storelocator.prototype.getAddress(store));
        html.push(Storelocator.prototype.getPhone(store));
        html.push(Storelocator.prototype.getDistanceAndTime(store));
        html.push(Storelocator.prototype.getSchedules(store));
        if (isFavoriteStoreLineDisplayable(store)) {
          html.push(Storelocator.prototype.getFavoriteStoreLine(store));
        }
        html.push(Storelocator.prototype.getStorePage(store));
        myCustomContent.innerHTML = html.join('');
        var intinaryButton = document.querySelector('.woosmap-slw-direction-button');
        var trackingObj = {
          'categorie': 'store',
          'action': 'store locator',
          'label': "itinerary"
        };
        intinaryButton.addEventListener('click', function () {
          hitEventTms(intinaryButton, 'gaEvent', JSON.stringify(trackingObj));
        });
        return myCustomContent;
      });
      myStoreLocator.setSummaryStoreRenderer(function (store) {
        var mySummaryContent = document.createElement('div');
        mySummaryContent.className = "m-storelocator__store-list".concat(isBmStyle ? '-bm' : '');
        var html = [];
        html.push("<h2 class='m-storelocator__name'>".concat(store.properties.name, "</h2>"));
        html.push(Storelocator.prototype.getSummaryAddress(store));
        html.push(Storelocator.prototype.getPhone(store));
        if (isFavoriteStoreLineDisplayable(store)) {
          html.push(Storelocator.prototype.getFavoriteStoreLine(store));
        } else {
          html.push(Storelocator.prototype.getStorePage(store));
        }
        html.push(Storelocator.prototype.getDistanceAndTime(store));
        mySummaryContent.innerHTML = html.join('');
        if (index < 1) {
          Storelocator.prototype.searchEvent();
        }
        return mySummaryContent;
      });
      Storelocator.prototype.loadStoreLocator(myStoreLocator);
      if (lm.localStorageLM.exist('id', 'sessionStorage', SESSION_STORESPACE_ID)) {
        Storelocator.prototype.initItineraryStore(myStoreLocator);
      } else if (device !== 'mobile') {
        Storelocator.prototype.initContextStore(myStoreLocator);
      }
    });
    window.addEventListener('contextualize', function (e) {
      Storelocator.prototype.storeLocContext(e.detail.store_id, e.detail.store_name);
    }, false);
    window.addEventListener('goToStorePage', function (e) {
      Storelocator.prototype.clickEvent('voir la page magasin');
      Storelocator.prototype.sendCDLEvent({
        'event_name': 'button.click',
        'event_data': {
          'button_name': 'go to store page',
          'store_name': e.detail.store_name
        }
      });
    }, false);
    _this.listenSearchInputEvent();
    return _this;
  }
  _inherits(Storelocator, _lm$Composant);
  return _createClass(Storelocator, [{
    key: "findInputElemWithoutListener",
    value: function findInputElemWithoutListener(mutationList) {
      return mutationList.map(function (mutation) {
        return mutation.target;
      }).map(function (mutationTarget) {
        return mutationTarget.querySelector('input');
      }).find(function (input) {
        return input && !input.getAttribute('listener');
      });
    }
  }, {
    key: "listenSearchInputEvent",
    value: function listenSearchInputEvent() {
      var _this2 = this;
      var componentNode = document.querySelector('#component-storelocator');
      var mutatorConfig = {
        subtree: true,
        childList: true
      };
      var mutationEventsCallback = function mutationEventsCallback(mutationList) {
        var inputElem = _this2.findInputElemWithoutListener(mutationList);
        if (inputElem) {
          inputElem.addEventListener('keyup', function (event) {
            searchInput = event.target.value;
            inputElem.setAttribute('listener', 'true');
          });
        }
      };
      var DOMObserver = new MutationObserver(mutationEventsCallback);
      DOMObserver.observe(componentNode, mutatorConfig);
    }
  }, {
    key: "loadStoreLocator",
    value: function loadStoreLocator(myStoreLocator) {
      myStoreLocator.setConf(storeLocatorConfig);
      var isMobile = false;
      if (device === 'mobile') {
        isMobile = true;
      }
      myStoreLocator.render(isMobile);
    }
  }, {
    key: "storeLocContext",
    value: function storeLocContext(storeId, storeName) {
      var d = new Date();
      d.setTime(d.getTime() + 390 * 24 * 60 * 60 * 1000);
      var expires = "expires=".concat(d.toUTCString());
      var today = new Date();
      var todayFormat = today.getFullYear() + "0".concat(today.getMonth() + 1).slice(-2) + "0".concat(today.getDate()).slice(-2);
      if (cookieDomain) {
        document.cookie = "".concat(COOKIE_STORE_ID_NAME, "=").concat(storeId, ";domain=").concat(cookieDomain, ";path=/;").concat(expires, ";SameSite=Lax;");
        document.cookie = "".concat(NEW_COOKIE_STORE_ID_NAME, "=").concat(storeId, ";domain=").concat(cookieDomain, ";path=/;").concat(expires, ";SameSite=Lax;");
        document.cookie = "store=store=".concat(storeId, "|dateContext=").concat(todayFormat, ";domain=").concat(cookieDomain, ";path=/;").concat(expires, ";SameSite=Lax;");
        // kill customer_context cookie to avoid conflict with store cookies
        document.cookie = "customer_context=;domain=".concat(cookieDomain, ";path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC;SameSite=Lax;");
      }
      lm.localStorageLM.set('context_status', 'context-manual', 390);
      this.isStoreIdParam('storeId');
      this.clickEvent('se contextualiser');
      this.sendCDLEvent({
        'event_name': 'shop.select',
        'event_data': {
          'shop_name': storeName,
          'feature_name': 'favorite store'
        }
      });
      if (referrerUrl !== '' && referrerUrl !== undefined) {
        window.location = referrerUrl;
      } else window.location.reload();
    }
  }, {
    key: "isStoreIdParam",
    value: function isStoreIdParam(storeId) {
      storeId = storeId !== 'undefined' ? storeId : '';
      history.replaceState(null, null, "".concat(location.protocol, "//").concat(location.host).concat(location.pathname).concat(location.search.replace(/[\?&]storeId=[^&]+/, '').replace(/^&/, '?')));
    }
  }, {
    key: "initContextStore",
    value: function initContextStore(myStoreLocator) {
      var storeId = lm.cookie.get(NEW_COOKIE_STORE_ID_NAME);
      if (storeId !== undefined && storeId !== null && storeId !== '') {
        myStoreLocator.setInitialStateToSelectedStore(storeId, 10);
      }
    }
  }, {
    key: "initItineraryStore",
    value: function initItineraryStore(myStoreLocator) {
      var storeSpaceId = lm.localStorageLM.get('id', 'sessionStorage', SESSION_STORESPACE_ID);
      if (storeSpaceId !== '' && storeSpaceId !== undefined && storeSpaceId !== null) {
        myStoreLocator.setInitialStateToDirections(storeSpaceId, 10, 'DRIVING', true);
      }
      lm.localStorageLM["delete"]('id', 'sessionStorage', SESSION_STORESPACE_ID);
    }
  }, {
    key: "getSchedules",
    value: function getSchedules(store) {
      if (crisisDataset && crisisDataset === 'false') {
        return this.getOpenings(store);
      }
    }
  }, {
    key: "getOpenings",
    value: function getOpenings(store) {
      var _this3 = this;
      var days = Object.values(Days);
      var schedules = '';
      days.forEach(function (day) {
        var hours = store.properties.weekly_opening[day.value];
        var isCurrentDay = new Date().getDay() === day.value % 7;
        var dayTranslation = day.translation;
        var dayAndHoursHtml = _this3.renderDayAndHours(hours, dayTranslation, isCurrentDay);
        schedules += dayAndHoursHtml;
      });
      return "\n    <div class='m-storelocator__schedules-block'>\n      <svg class='ku-icon-24 m-storelocator__icon'>\n        <use xlink:href='#Media_TimeRead_24px' href='#Media_TimeRead_24px'></use>\n      </svg>\n      <table class='m-storelocator__schedules'>\n        <caption class='kl-hidden-accessibility'>".concat(storelocator.i18n.typo_schedules, "</caption>\n        <tbody>\n          ").concat(schedules, "\n        </tbody>\n      </table>\n    </div>");
    }
  }, {
    key: "renderDayAndHours",
    value: function renderDayAndHours(hours, day, isCurrentDay) {
      var dayHtml = "<th class='m-storelocator__schedule-day' ".concat(isCurrentDay ? "aria-current='date'" : "", ">").concat(day, "</th>");
      var hoursHtml = this.renderHours(hours);
      return "<tr class='".concat(isCurrentDay ? "is-current" : "", "'>").concat(dayHtml, "<td>").concat(hoursHtml, "</td></tr>");
    }
  }, {
    key: "renderHours",
    value: function renderHours(_ref) {
      var hours = _ref.hours;
      if (hours.length > 0) {
        var openingHours = "".concat(hours[0].start, " - ").concat(hours[0].end);
        var additionalHours = hours.length > 1 ? "".concat(hours[1].start, " - ").concat(hours[1].end) : '';
        return "".concat(openingHours).concat(additionalHours ? '<br>' + additionalHours : '');
      }
      return storelocator.i18n.closed_days;
    }
  }, {
    key: "getDistanceAndTime",
    value: function getDistanceAndTime(store) {
      if (store.properties.distance) {
        var distanceLabel = store.properties.distance ? (store.properties.distance / 1000).toFixed(1) + storelocator.i18n.distance_metric : '';
        return "<span class='m-storelocator__distance'>".concat(distanceLabel, "</span>");
      } else return '';
    }
  }, {
    key: "getPhone",
    value: function getPhone(store) {
      return "<p class='m-storelocator__phone'><svg class='ku-icon-24'><use xlink:href='#User_Contact_Phone_24px' href='#User_Contact_Phone_24px'></use></svg><span class='m-storelocator__phone-number'>".concat(store.properties.contact.phone, "</span></p>");
    }
  }, {
    key: "getStorePage",
    value: function getStorePage(store) {
      var url = store.properties.contact.website;
      return "<a data-cerberus=\"storelocatorSpaceStoreLink\" href=\"".concat(url, "\" aria-label=\"").concat(storelocator.i18n.link_store_text, " ").concat(store.properties.name, " ").concat(store.properties.address.lines, " ").concat(store.properties.address.zipcode, " ").concat(store.properties.address.city, "\" class='mc-button mc-button--bordered mc-button--full m-storelocator__store-page' onclick='window.dispatchEvent(new CustomEvent(\"goToStorePage\", {\"detail\": {\"store_name\": \"").concat(store.properties.name.replace(/'/g, ' '), "\" } }))'>").concat(storelocator.i18n.link_store_text, "</a>");
    }
  }, {
    key: "getAddress",
    value: function getAddress(store) {
      var addressCityCode = "".concat(store.properties.address.zipcode, " ").concat(store.properties.address.city);
      return "<p class='m-storelocator__address'><svg class='ku-icon-24 m-storelocator__icon'><use xlink:href='#Store_Monochrome_StoreLocation_24px' href='#Store_Monochrome_StoreLocation_24px'></use></svg><span class='m-storelocator__lines m-storelocator__summary-address'>".concat(store.properties.address.lines, "</span><span class='m-storelocator__lines m-storelocator__summary-address'>").concat(addressCityCode, "</span>") + '</p>';
    }
  }, {
    key: "getSummaryAddress",
    value: function getSummaryAddress(store) {
      var addressCityCode = "".concat(store.properties.address.zipcode, " ").concat(store.properties.address.city);
      return "<p class='m-storelocator__address'> <span class='m-storelocator__lines'>".concat(store.properties.address.lines, "</span> ") + "<span class='m-storelocator__lines'>".concat(addressCityCode, "</span> </p>");
    }
  }, {
    key: "getFavoriteStoreLine",
    value: function getFavoriteStoreLine(store) {
      var storeId = lm.cookie.get(NEW_COOKIE_STORE_ID_NAME);
      var favoriteStoreLabel = storelocator.i18n.contextualized_button_label;
      var favoriteClass = 'm-storelocator__context-store';
      var onCLickContext = "onclick='window.dispatchEvent(new CustomEvent(\"contextualize\", { \"detail\": { \"store_id\": ".concat(store.properties.store_id, ", \"store_name\": \"").concat(store.properties.name.replace(/'/g, ' '), "\" } }))'");
      if (storeId !== undefined && storeId !== null && storeId !== '') {
        if (storeId === store.properties.store_id) {
          favoriteClass = 'm-storelocator__favorite-store';
          favoriteStoreLabel = storelocator.i18n.favorite_store;
          onCLickContext = '';
          return "<p class='m-storelocator__favorite ".concat(favoriteClass, "' data-storeid='").concat(store.properties.store_id, "' ").concat(onCLickContext, " data-cerberus='storelocatorFavoriteStore'> <svg class='ku-icon-16'><use xlink:href='#Navigation_Publish_Favorite_16px' href='#Navigation_Publish_Favorite_16px'></use></svg>").concat(favoriteStoreLabel, "</p>");
        }
      }
      return "<button data-cerberus='storelocatorFavoriteStore' class='mc-button m-storelocator__favorite  mc-button--full  ".concat(favoriteClass, "' data-storeid='").concat(store.properties.store_id, "' ").concat(onCLickContext, "' ><svg class='ku-icon-16 mc-button__icon'><use xlink:href='#Navigation_Publish_Favorite_16px' href='#Navigation_Publish_Favorite_16px'></use></svg> <span class='mc-button__label'>").concat(favoriteStoreLabel, " </span></button>");
    }
  }, {
    key: "searchEvent",
    value: function searchEvent() {
      var _this4 = this;
      var inputValue = document.querySelector('#component-storelocator input');
      if (inputValue !== null && inputValue !== undefined) {
        var searchValue = document.querySelector('#component-storelocator input').value;
        index = index + 1;
        setTimeout(function () {
          hitEventTms(window, 'gaEvent', JSON.stringify({
            'categorie': 'magasin',
            'action': 'recherche',
            'label': searchValue
          }));
          _this4.sendCDLEvent({
            'event_name': 'internal_search_result.display',
            'event_data': {
              'ise_keyword': searchInput,
              'ise_name': 'store locator'
            }
          });
          index = 0;
        }, 500);
      }
    }
  }, {
    key: "clickEvent",
    value: function clickEvent(label) {
      hitEventTms(window, 'gaEvent', JSON.stringify({
        'categorie': 'magasin',
        'action': 'magasins - recherche',
        'label': label
      }));
    }
  }, {
    key: "sendCDLEvent",
    value: function sendCDLEvent(eventContent) {
      hitEventTms(window, 'cdl_event', JSON.stringify(eventContent));
    }
  }]);
}(lm.Composant); // Add Sentry Tag
lm.sentry.configureScope(function (scope) {
  scope.setTag('kobi.composant', 'storelocator');
});
lm.DOMReady(function () {
  var StorelocatorModule = new Storelocator('storelocator');
});